/** 订舱类通知类型 */
export const ORDER_NOTICE_TYPES = [3, 4, 5, 6]

export const ORDER_NOTICE_TITLES = {
  3: '新订舱待处理',
  4: '订单拒绝原因',
  5: '订舱申请已放舱',
  6: '订舱订单被取消'
}

export function parseOrderNoticePayload(msg) {
  if (!msg || !ORDER_NOTICE_TYPES.includes(Number(msg.noticeType))) {
    return null
  }
  const raw = msg.content
  if (!raw) return null
  if (typeof raw === 'object') return raw
  try {
    const data = JSON.parse(raw)
    return data && typeof data === 'object' ? data : null
  } catch (e) {
    return null
  }
}

export function getNoticeTypeText(type) {
  const map = {
    0: '通知',
    1: '日程提醒',
    3: '新订舱订单',
    4: '拒绝订舱',
    5: '订单放舱',
    6: '取消订舱'
  }
  return map[Number(type)] || '通知'
}

export function getNoticeTitle(msg) {
  if (!msg) return '消息详情'
  const type = Number(msg.noticeType)
  if (ORDER_NOTICE_TYPES.includes(type)) {
    return ORDER_NOTICE_TITLES[type] || msg.title || '消息详情'
  }
  return msg.title || '消息详情'
}

export function getNoticePreview(msg) {
  if (!msg) return ''
  const payload = parseOrderNoticePayload(msg)
  if (payload) {
    return payload.content || payload.title || msg.title || ''
  }
  return msg.content || ''
}

export function isOrderNotice(msg) {
  return ORDER_NOTICE_TYPES.includes(Number(msg && msg.noticeType)) && !!parseOrderNoticePayload(msg)
}
